<template>
  <div class="tc-container">
    <div class="tc-chart">
      <div ref="myChart" class="myChart"></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        colorArr: ['#F44E33', '#F9F615', '#02FFA3', '#0891FA'],
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let that = this
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option = (option = {
          backgroundColor: 'rgba(0, 0, 0, 0)',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              // type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: '2%',
            right: '2%',
            bottom: '18%',
            top: '12%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: [
              '华为',
              '苹果',
              '三星',
              'HTC',
              'OPPO',
              'VIVO',
              '小米',
              '魅族',
              '荣耀',
              'LG',
            ],
            axisLine: {
              lineStyle: {
                color: 'white',
              },
            },
            axisLabel: {
              // interval: 0,
              // rotate: 40,
              fontSize: 10,
              textStyle: {},
              padding: 5,
            },
            axisTick: {
              show: false, //隐藏X轴刻度
            },
          },
          yAxis: {
            type: 'value',
            axisLine: {},
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisLabel: {
              show: false,
            },
          },
          series: [
            {
              name: '手机厂商TOP10',
              type: 'bar',
              barWidth: '10px',
              itemStyle: {
                normal: {
                  color: function (params) {
                    return that.colorArr[
                      params.dataIndex >= 3 ? 3 : params.dataIndex
                    ]
                  },
                  barBorderRadius: [12, 12, 0, 0],
                },
              },
              data: [400, 380, 360, 340, 320, 300, 280, 260, 240, 220],
            },
          ],
        })
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    width: 100%;

    .tc-chart {
      width: 100%;
      height: 11.458vw;
      margin: 0 auto;

      .myChart {
        width: 100%;
        height: 11.458vw;
      }
    }
  }
</style>
